// extracted by mini-css-extract-plugin
export var compactFilters = "_ex-4";
export var detailImage = "_ex-1";
export var dropdownContainer = "_ex-2";
export var imageContainer = "_ex-0";
export var selectedCard = "_ex-3";